import React from "react";

import PropTypes from "prop-types";

import TimeGrid from "./TimeGrid";
import { navigate } from "./utils/constants";

function Week({
	date,
	localizer,
	max = localizer.endOf(new Date(), "day"),
	min = localizer.startOf(new Date(), "day"),
	scrollToTime = localizer.startOf(new Date(), "day"),
	enableAutoScroll = true,
	...props
}) {
	const currRange = React.useMemo(() => Week.range(date, { localizer }), [date, localizer]);

	return (
		<TimeGrid
			range={currRange}
			eventOffset={15}
			localizer={localizer}
			min={min}
			max={max}
			scrollToTime={scrollToTime}
			enableAutoScroll={enableAutoScroll}
			{...props}
		/>
	);
}

Week.days = 7;

Week.propTypes = {
	date: PropTypes.instanceOf(Date).isRequired,
	localizer: PropTypes.any,
	min: PropTypes.instanceOf(Date),
	max: PropTypes.instanceOf(Date),
	scrollToTime: PropTypes.instanceOf(Date),
	enableAutoScroll: PropTypes.bool,
	timezones: PropTypes.object,
};

Week.defaultProps = TimeGrid.defaultProps;

Week.navigate = (date, action, { localizer }) => {
	const days = Week.days;
	switch (action) {
		case navigate.PREVIOUS: {
			if (days == 7) {
				return localizer.add(date, -1, "week");
			} else {
				return localizer.add(date, -days, "days");
			}
		}
		case navigate.NEXT: {
			if (days == 7) {
				return localizer.add(date, 1, "week");
			} else {
				return localizer.add(date, days, "days");
			}
		}

		default:
			return date;
	}
};

Week.range = (date, { localizer }) => {
	const days = Week.days;
	let start;
	let end;
	if (days < 7) {
		const daysAfter = Math.ceil((days - 1) / 2);
		const daysBefore = Math.floor((days - 1) / 2);
		start = localizer.startOf(localizer.add(date, -daysBefore, "days"), "day");
		end = localizer.endOf(localizer.add(date, daysAfter, "days"), "day");
	} else {
		let firstOfWeek = localizer.startOfWeek();
		start = localizer.startOf(date, "week", firstOfWeek);
		end = localizer.endOf(date, "week", firstOfWeek);
	}

	return localizer.range(start, end);
};

Week.title = (date, { localizer }) => {
	const days = Week.days;
	const range = [
		...Week.range(date, {
			localizer: localizer,
			days,
		}),
	];
	const start = range[0];
	const end = range[range.length - 1];

	const isThisYear = start.getFullYear() === new Date().getFullYear();
	if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
		return localizer.format(start, `MMMM${isThisYear ? "" : " yyyy"}`);
	} else {
		const format = `MMM${isThisYear ? "" : " yyyy"}`;
		return `${localizer.format(start, format)} — ${localizer.format(end, format)}`;
	}
};

export default Week;
